<div class="main mx-auto">
  <div class="container-fluid">
    <div class="row border p-4 align-items-center">
      <div class="col-lg-2 pt-2">

        <div class="input-group ">
          <input class="form-control " type="text" placeholder="Search Product..." (keyup.enter)="search()" [(ngModel)]="searchText">
          <div class="input-group-append">
            <button class="btn btn-danger" (click)="search()" type="button"><i class="fa fa-search"></i></button>
          </div>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="form-group mb-0">
          <!--<label>View: </label>-->
          <ng-select [items]="viewList" appearance="outline" class="custom"
                     bindLabel="id"
                     bindValue="id"
                     [searchable]="false" [clearable]="false"
                     [placeholder]="'View'"
                     [(ngModel)]="selectedView">
            <ng-template ng-label-tmp let-item="item">
              <!--<span class="font-weight-bold">View: </span>-->
              <img height="30" [src]="item.url" />
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-index="index">
              <img height="27" [src]="item.url" />
            </ng-template>
          </ng-select>
        </div>


      </div>
      <div class="col-lg-3">
        <div class="form-group mb-0">


          <!--<label class="d-block">Sort by: </label>-->

          <ng-select class="d-inline-block w-75" [items]="sortByList" appearance="outline"
                     bindLabel="name"
                     bindValue="sortName"
                     [searchable]="false" [clearable]="false"
                     [placeholder]="'Sort by'"
                     [(ngModel)]="selectedSort"
                     (change)="search()">
            <ng-template ng-label-tmp let-item="item">
              <span class="font-weight-bold"> {{item.name}}</span>
            </ng-template>
          </ng-select>
          <button class="btn btn-danger ml-2 d-inline-block pt-2 mt-n1" (click)="sort()">
            <i class="fa fa-sort-alpha-asc" *ngIf="sortBy == 'asc'"></i>
            <i class="fa fa-sort-alpha-desc" *ngIf="sortBy == 'desc'"></i>
          </button>
        </div>
      </div>
      <div class="col-lg-2">
        <div class="form-group mb-0">
          <!--<label>Products Per Page: </label>-->
          <ng-select [items]="pageList" appearance="outline"
                     bindLabel="name"
                     bindValue="name"
                     [searchable]="false" [clearable]="false"
                     [placeholder]="'Products Per Page'"
                     [(ngModel)]="selectPageSize"
                     (change)="changePageSize()">
            <ng-template ng-label-tmp let-item="item">
              <span class="font-weight-bold"> {{item.name}}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div class="col-lg-2 text-center">
        <span class="result-count">Showing {{result}} results</span>
      </div>
    </div>
  </div>

  <div class="container-fluid px-0">
    <div class="content-container">
      <div class="left">
        <div class="refiner-container">
          <div class="text-right pr-4 pt-1">
            <button class="btn btn-link font-weight-bold" (click)="reset()">Clear Filter</button>
          </div>
          <div class="refiner">

            <ul class="refiner-ul">
              <li *ngFor="let filter of filterList">
                <a class="header" (click)="toggleFilter(filter.id)">
                  <span>{{filter.name}}</span>
                  <i class="fa fa-plus-circle header-icon" *ngIf="!filter.isShow"></i>

                  <i class="fa fa-minus-circle header-icon" *ngIf="filter.isShow"></i>
                </a>
                <ul class="ml-3" *ngIf="filter.isShow">
                  <li *ngFor="let child of filter.selection;let i = index;">

                    <a>
                      <span>

                        <div class="form-check">
                          <input class="form-check-input cursor-pointer" type="checkbox" (ngModelChange)="child.isChecked = $event;triggerFilter()" [(ngModel)]="child.isChecked">
                          <label [ngClass]="{'font-weight-bold':child.isChecked}" class="form-check-label cursor-pointer" (click)="child.isChecked = !child.isChecked;triggerFilter()">
                            {{child.name}}
                          </label>
                        </div>
                      </span>
                    </a>
                  </li>
                </ul>
              </li>

            </ul>
          </div>
        </div>
      </div>
      <div class="product-container">
        <div class="row mt-3 ml-2">
          <div class="col-md-12">
            <div class="d-flex justify-content-between">
              <span class="total-items">Total: {{collectionSize}} items</span>

              <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="getProducts()" [maxSize]="5" [rotate]="true" [boundaryLinks]="true">
              </ngb-pagination>
            </div>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col-md-12 text-center">
            <spinner [withmargin]="true" *ngIf="isLoading"></spinner>
          </div>
          <ng-container *ngIf="!isLoading">
            <!-- col-lg-3 col-md-4 col-sm-4 col-6 -->
            <product-thumbnail class="pt-4 pb-4" [ngClass]="{'col-3':selectedView == 4, 'col-4':selectedView == 3,'col-6':selectedView == 2,'col-12':selectedView == 1}"
                               *ngFor="let item of productList" [view]="selectedView" [productDetail]="item" (onClickThumbnail)="onClickThumbnail($event)" [isFromModal]="isFromModal"></product-thumbnail>
          </ng-container>
        </div>
        <div class="row mt-3 ml-2">
          <div class="col-md-12">
            <div class="d-flex justify-content-between">
              <span class="total-items">Total: {{collectionSize}} items</span>
              <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize" (pageChange)="getProducts()" [maxSize]="5" [rotate]="true" [boundaryLinks]="true">
              </ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
